import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga';
const logOutMiddleware = (store) => (next) => (action) => {
  
  if (action.type === 'auth/logout') {
  }
  next(action);
};

export default function configureAppStore() {
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer,
    middleware: (config) => {
      return [...config({ thunk: false }), sagaMiddleware, logOutMiddleware];
    },
  });

  sagaMiddleware.run(rootSaga);

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
}
